export default __webpack_public_path__ + "static/media/createExisting.3b8dad9f.svg";